import { render, staticRenderFns } from "./businessplan.vue?vue&type=template&id=355beec0&scoped=true&"
import script from "./businessplan.vue?vue&type=script&lang=js&"
export * from "./businessplan.vue?vue&type=script&lang=js&"
import style0 from "./businessplan.vue?vue&type=style&index=0&id=355beec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355beec0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VList,VListItem,VMenu,VSpacer})
